import type { SchemaRegion } from "../../../api/restaurantSchema";
import RegionSegmentedTabs from "../../../components/restaurant-schema/RegionSegmentedTabs";

/**
 * Табовете на регионите в „Резервации" — общият сегментиран контрол
 * („Основна зала 23 маси · 106 места", като в „Конфигурация на маси" и
 * „Схема на заведението"), 36px — колкото денят и „Нова резервация".
 */
const ReservationRegionTabs = ({
  regions,
  activeId,
  onChange,
}: {
  regions: SchemaRegion[];
  activeId: number | null;
  onChange: (regionId: number) => void;
}) => <RegionSegmentedTabs regions={regions} activeId={activeId} onChange={onChange} compact />;

export default ReservationRegionTabs;
